import BigNumber from 'bignumber.js';
export const NAME_PART_REGEX = /^[A-Za-z\u4e00-\u9fa5]{1,20}$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validator = {
  required({ message }: { message: string }) {
    return (value: unknown) => {
      if (!value || (typeof value === 'string' && value.trim() === '')) {
        return message;
      }
    };
  },
  gt(
    v: number | bigint | string | undefined | null,
    {
      message,
    }: {
      message: string;
    }
  ) {
    if (v === undefined || v === null) {
      return () => {
        return undefined;
      };
    }

    return (value: unknown) => {
      if (typeof value === 'string') {
        if (!value) {
          return message;
        }

        if (new BigNumber(value).lte(v)) {
          return message;
        }
      }
    };
  },
  gte(
    v: number | bigint | string | undefined | null,
    {
      message,
    }: {
      message: string;
    }
  ) {
    if (v === undefined || v === null) {
      return () => {
        return undefined;
      };
    }

    return (value: unknown) => {
      if (typeof value === 'string') {
        if (!value) {
          return message;
        }

        if (new BigNumber(value).lt(v)) {
          return message;
        }
      }
    };
  },
  lte(
    v: number | bigint | string,
    {
      message,
    }: {
      message: string;
    }
  ) {
    return (value: unknown) => {
      if (typeof value === 'string') {
        if (new BigNumber(value).gt(v)) {
          return message;
        }
      }
    };
  },
  maxLength({ message, max }: { message: string; max: number }) {
    return (value: unknown) => {
      if (typeof value !== 'string') {
        return message;
      }

      if (value.length > max) {
        return message;
      }
    };
  },
  email({ message }: { message: string }) {
    return (value: unknown) => {
      if (typeof value !== 'string') {
        return message;
      }

      if (!EMAIL_REGEX.test(value)) {
        return message;
      }
    };
  },
  name({ message }: { message: string }) {
    return (value: unknown) => {
      if (typeof value !== 'string') {
        return message;
      }

      if (!NAME_PART_REGEX.test(value)) {
        return message;
      }
    };
  },
};
